import api from './api';

const trfService = {
  getConfig: async () => {
    const response = await api.get('/trf/config');
    return response.data;
  },

  saveConfig: async (payload) => {
    const response = await api.put('/trf/config', payload);
    return response.data;
  },

  // printType: 'AUTO' (after registration save) | 'MANUAL' (Print TRF button)
  prepare: async (labNo, printType = 'MANUAL') => {
    const response = await api.post(
      `/trf/registration/${encodeURIComponent(labNo)}/prepare`,
      null,
      { params: { printType } }
    );
    return response.data;
  },

  logPrint: async ({ labNo, trfNos, printType, status, errorMessage }) => {
    const response = await api.post('/trf/print-log', {
      ledgerTransactionNo: labNo,
      trfNos,
      printType,
      status,
      errorMessage: errorMessage || null,
    });
    return response.data;
  },
};

export default trfService;
